export type ActionType =
  | 'breakingAction'
  | 'breakingActions'
  | 'nonBreakingActions';

export enum WorkflowActionType {
  BREAKING_ACTION = 'breakingAction',
  BREAKING_ACTIONS = 'breakingActions',
  NON_BREAKING_ACTIONS = 'nonBreakingActions',
}
